import { Temporal } from "temporal-polyfill";
import { parseAuctionInstant } from "../helpers/auctionDateTime";
import Constants from "../models/utility/Constants";
import { ICountdownTimer } from "../models/utility/ICountdownTimer";

const expired: ICountdownTimer = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
};

export default class TimerProvider {
    public static RemainingTime(date: string, offset: number): ICountdownTimer {
        const target = parseAuctionInstant(date);
        if (!target) {
            return expired;
        }

        const now = Constants.CurrentDate().getTime() + offset;
        const remaining = target.epochMilliseconds - now;
        if (!Number.isFinite(remaining) || remaining < 0) {
            return expired;
        }

        // Balanced against the clock alone, so a countdown never depends on a
        // timezone's calendar days.
        const { days, hours, minutes, seconds } = Temporal.Duration.from({
            milliseconds: remaining
        }).round({
            largestUnit: "day",
            smallestUnit: "second",
            roundingMode: "trunc"
        });

        return { days, hours, minutes, seconds };
    }
}
